import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-ticketcobitkat-list-view',
  imports: [],
  templateUrl: './ticketcobitkat.list-view.html',
  styleUrls: ['./ticketcobitkat.list-view.css'],
})
export class TicketcobitkatListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
